const PERMISSIONS = {
  USER_ADD: 1,
  USER_EDIT: 2,
  USER_VIEW: 3,
  USER_REMOVE: 4,

  CUSTOMER_ADD: 5,
  CUSTOMER_EDIT: 6,
  CUSTOMER_VIEW: 7,
  CUSTOMER_REMOVE: 8,

  PROVIDER_ADD: 9,
  PROVIDER_EDIT: 10,
  PROVIDER_VIEW: 11,
  PROVIDER_REMOVE: 12,

  PRODUCT_ADD: 13,
  PRODUCT_EDIT: 14,
  PRODUCT_VIEW: 15,
  PRODUCT_REMOVE: 16,

  INVENTORY: 17,
  CATEGORY: 18,
  BRAND: 19,
  UNITY: 20,
  SHIPPING: 21,
  PAYMENT_METHOD: 22,
  DISCOUNT_LIST: 23,
  CONFIG: 24,

  GOAL_ADD: 25,
  GOAL_EDIT: 26,
  GOAL_VIEW: 27,
  GOAL_REMOVE: 28,

  REQUEST_ADD: 29,
  REQUEST_EDIT: 30,
  REQUEST_VIEW: 31,
  REQUEST_REMOVE: 32,

  PURCHASE_ADD: 33,
  PURCHASE_EDIT: 34,
  PURCHASE_VIEW: 35,
  PURCHASE_REMOVE: 36,

  REVENUE_ADD: 37,
  REVENUE_EDIT: 38,
  REVENUE_VIEW: 39,
  REVENUE_REMOVE: 40,

  EXPENSE_ADD: 41,
  EXPENSE_EDIT: 42,
  EXPENSE_VIEW: 43,
  EXPENSE_REMOVE: 44,

  ACCOUNT_ADD: 45,
  ACCOUNT_EDIT: 46,
  ACCOUNT_VIEW: 47,
  ACCOUNT_REMOVE: 48,

  DASHBOARD: 49,

  REPBASIC: 50,
  REPFINANCIAL: 51,
  REPPURCHASE: 52,
  REPREQUEST: 53,
  REPMANAGE: 54,

  SERVICE_ADD: 55,
  SERVICE_EDIT: 56,
  SERVICE_VIEW: 57,
  SERVICE_REMOVE: 58,

  FISCAL_ADD: 59,
  FISCAL_VIEW: 60,
  FISCAL_REMOVE: 61,

  CLASSIFICATION: 62,
  ACCOUNT_MOVEMENT: 63,

  REQUEST_BILLING: 64,

  CONTRACT_ADD: 65,
  CONTRACT_EDIT: 66,
  CONTRACT_VIEW: 67,
  CONTRACT_REMOVE: 68,

  PRODUCT_EDIT_BATCH: 70,
  SERVICE_EDIT_BATCH: 71,
  CRM_OPPORTUNITY_VIEW: 76,
  CRM_OPPORTUNITY_ADD: 77,
  CRM_OPPORTUNITY_EDIT: 78,
  CRM_OPPORTUNITY_REMOVE: 79,
  BANK_RECONCILIATION_VIEW: 72,
  BANK_RECONCILIATION_CONFIGURE: 73,
  BANK_RECONCILIATION_IMPORT: 74,
  BANK_RECONCILIATION_RECONCILE: 75,
}

const BASIC_GROUP = 1
const REQUEST_GROUP = 2
const FISCAL_GROUP = 3
const PURCHASE_INVENTORY_GROUP = 4
const FINANCIAL_GROUP = 5
const REPORT_GROUP = 6
const TOOLS_GROUP = 7

const GROUPS = {
  [BASIC_GROUP]: 'Cadastros',
  [REQUEST_GROUP]: 'Vendas',
  [FISCAL_GROUP]: 'Fiscal',
  [PURCHASE_INVENTORY_GROUP]: 'Compras/Estoque',
  [FINANCIAL_GROUP]: 'Financeiro',
  [REPORT_GROUP]: 'Relatórios',
  [TOOLS_GROUP]: 'Ferramentas',
}

export {
  PERMISSIONS,
  GROUPS,

  BASIC_GROUP,
  REQUEST_GROUP,
  FISCAL_GROUP,
  PURCHASE_INVENTORY_GROUP,
  FINANCIAL_GROUP,
  REPORT_GROUP,
  TOOLS_GROUP,
}
